/* import __COLOCATED_TEMPLATE__ from './intermediate-timing-association-table.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { inject as service } from '@ember/service';

export default class FinishTimingAssociationTableComponent extends Component 
{
	@service store;
	@service ajax;

	@tracked enteredBib = null;
	
	get clearDisabled()
	{
		return this.args.selectedTimeRecord == null && this.args.selectedBibRecord == null;
	}
	
	get associateBibDisabled()
	{
		return this.args.selectedTimeRecord == null || this.args.selectedBibRecord == null || this.args.selectedTimeRecord == this.args.selectedBibRecord;
	}
	
	get disassociateBibDisabled()
	{
		return this.args.selectedTimeRecord != null && (this.args.selectedTimeRecord.EntryId == null || this.args.selectedBibRecord != null);
	}
	
	get clearEntryDisabled()
	{
		return this.args.selectedTimeRecord != null && (this.args.selectedTimeRecord.EntryId == null || this.args.selectedBibRecord != null);
	}
	
	get dupImpulseDisabled()
	{
		return this.args.selectedTimeRecord == null || this.args.selectedBibRecord != null;
	}
	
	@action
	clear()
	{
		this.args.timeRecordSelectAction(null);
		this.args.bibRecordSelectedAction(null);
		this.enteredBib = null;
	}
	
	@action
	async associateBibRecord()
	{
		var sTR = this.args.selectedTimeRecord;
		var sBR = this.args.selectedBibRecord;
		
		if(sTR == null)
		{
			alert("no time record selected");
			return;
		}
		if(sBR == null)
		{
			alert("no bib record selected");
			return;
		}
		
		if(sBR.EntryId == null)
		{
			alert("invalid bib number");
			return;
		}
		if(sBR.impulseId != undefined)
		{
			alert("bib record already associated with impulse");
			return;
		}
		if(sTR.EntryId != null)
		{
			alert("time record already associated with an entry");
			return;
		}
		
		const response = await this.ajax.request("/intermediate-timing-records/"+sTR.id+"/associateWithBibRecord/"+sBR.id);
		
		if(response.error != null)
		{
			alert(response.error);
			return;
		}
		
		this.clear();
	}
	
	@action
	async disassociateBibRecord()
	{
		var sTR = this.args.selectedTimeRecord;
		var sBR = this.args.selectedBibRecord;
		
		if(sTR == null)
		{
			alert("no time record selected");
			return;
		}
		if(sBR != null)
		{
			alert("bib record must be cleared");
			return;
		}
		
		if(sTR.EntryId == null)
		{
			alert("time record has no bib associated");
			return;
		}
		if(sTR.impulseId == undefined)
		{
			alert("time record has no impulse associated");
			return;
		}
	
		const response = await this.ajax.request("/intermediate-timing-records/"+sTR.id+"/disassociateBibRecord");
		
		if(response.error != null)
		{
			alert(response.error);
		}
		
		this.clear();
	}
	
	@action
	async dupImpulse()
	{
		var sTR = this.args.selectedTimeRecord;
		
		var associationTable = this;
		
		if(sTR == null)
		{
			alert("no impulse selected");
			return;
		}
		
		const response = await this.ajax.request("/intermediate-timing-records/"+sTR.id+"/dupImpulse");
		
		if(response.error != null)
		{
			alert(response.error);
		}
		
		this.clear();
	}
	
	@action
	async clearEntry()
	{
		var sTR = this.args.selectedTimeRecord;
		var sBR = this.args.selectedBibRecord;
		
		var associationTable = this;
		
		if(sBR != null)
		{
			alert("selected bib must be cleared");
			return;
		}
		if(sTR == null)
		{
			alert("no time record selected");
			return;
		}
		
		if(sTR.EntryId == null)
		{
			alert("time record has no entry");
			return;
		}
		
		const response = await this.ajax.request("/intermediate-timing-records/"+sTR.id+"/clearEntry");
		
		if(response.error != null)
		{
			alert(response.error);
		}
		
		this.clear();
	}
	
	@action
	async bibEntered(value)
	{
		var associationTable = this;
		
		var sTR = this.args.selectedTimeRecord;
		
		if(sTR == null)
		{
			alert("no time record selected");
			return;
		}
		
		const response = await this.ajax.request("/intermediate-timing-records/"+sTR.id+"/associateWithBib/"+this.enteredBib);
		
		if(response.error != null)
		{
			alert(response.error);
			return;
		}
		
		this.clear();
	}
	
	@action
	async clearBibAuto()
	{
		var sBR = this.args.selectedBibRecord;
		
		var associationTable = this;
		
		if(sBR == null)
		{
			alert("no bib record selected");
			return;
		}
		
		const response = await this.ajax.request("/intermediate-timing-records/"+sBR.id+"/removeFromAutoAssociation");
		
		if(response.error != null)
		{
			alert(response.error);
		}
			
		this.clear();
	}
	
	@action
	async setBibAuto()
	{
		var sBR = this.args.selectedBibRecord;
		
		var associationTable = this;
		
		if(sBR == null)
		{
			alert("no bib record selected");
			return;
		}
		
		const response = await this.ajax.request("/intermediate-timing-records/"+sBR.id+"/addToAutoAssociation");
		
		if(response.error != null)
		{
			alert(response.error);
		}
		
		this.clear();
	}
	
	@action
	async clearBibPosted()
	{
		var sBR = this.args.selectedBibRecord;
		
		var associationTable = this;
		
		if(sBR == null)
		{
			alert("no bib record selected");
			return;
		}
		
		const response = await this.ajax.request("/intermediate-timing-records/"+sBR.id+"/clearPosted");
		
		if(response.error != null)
		{
			alert(response.error);
		}
		
		this.clear();
	}
	
	@action
	async setBibPosted()
	{
		var sBR = this.args.selectedBibRecord;
		
		var associationTable = this;
		
		if(sBR == null)
		{
			alert("no bib record selected");
			return;
		}
		
		const response = await this.ajax.request("/intermediate-timing-records/"+sBR.id+"/setPosted");
		
		if(response.error != null)
		{
			alert(response.error);
		}
		
		this.clear();
	}
	
	@action
	async clearTimeRecordAuto()
	{
		var sTR = this.args.selectedTimeRecord;
		
		var associationTable = this;
		
		if(sTR == null)
		{
			alert("no time record selected");
			return;
		}
		
		const response = await this.ajax.request("/intermediate-timing-records/"+sTR.id+"/removeFromAutoAssociation");
		
		if(response.error != null)
		{
			alert(response.error);
		}
		
		this.clear();
	}
	
	@action
	async setTimeRecordAuto()
	{
		var sTR = this.args.selectedTimeRecord;
		
		var associationTable = this;
		
		if(sTR == null)
		{
			alert("no time record selected");
			return;
		}
		
		const response = await this.ajax.request("/intermediate-timing-records/"+sTR.id+"/addToAutoAssociation");
		
		if(response.error != null)
		{
			alert(response.error);
		}
		
		this.clear();
	}
}